import AppConfig from "util/AppConfig";
import CloudEmailFormGroup from "./user/CloudEmailFormGroup";
import CloudPasswordFormGroup, { validateCloudPasswords } from "./user/CloudPasswordFormGroup";
import { parseErrorResponse, customizeUserPayload } from "./user/Utils";
import CloudFooter from "./footer/CloudFooter";
const cloudExport = AppConfig.isCloud() ? {
  cloud: {
    oktaUserForm: {
      fields: {
        username: null,
        email: CloudEmailFormGroup,
        password: CloudPasswordFormGroup
      },
      validations: {
        password: validateCloudPasswords
      },
      extractSubmitError: parseErrorResponse,
      onCreate: customizeUserPayload
    }
  },
  pageFooter: [
    {
      component: CloudFooter
    }
  ]
} : {};
export default cloudExport;
